// JavaScript source code
import './../styles/AccountComponents/GamePage.css';
import { useEffect, useState, useRef } from 'react';
import AWS from "aws-sdk";
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';
import { XhrHttpHandler } from '@aws-sdk/xhr-http-handler';
import { Upload } from '@aws-sdk/lib-storage';
import { GetAccessToken, IsValid, FetchAccountInfo } from "./../Utilities";
import GameCard from './../components/library/Game.js';
import { Chart } from "react-google-charts";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { MediaType } from './../components/library/Popup.js';

function GamePage({ gameId }) {
    const [subPage, setSubPage] = useState();

    function InfoPageClicked() {
        setSubPage("gameInfo");
    }

    function DataPageClicked() {
        setSubPage("gameData");
    }

    return (
        <div>
            <div className="gameSubPageButtons">
                <button className="gameInfoButton" onClick={InfoPageClicked} style={{backgroundColor: (subPage === undefined || subPage === "gameInfo") ? "#FFCF00" : 'lightgrey'}}>Game Info</button>
                <button className="gameDataButton" onClick={DataPageClicked} style={{ backgroundColor: (subPage === "gameData") ? "#FFCF00" : 'lightgrey' }}>Game Data</button>
            </div>
            {(subPage === undefined || subPage === "gameInfo") &&
                < GameInfo gameId={gameId} />}
            {subPage === "gameData" &&
                < GameDataPage gameId={gameId} />}
        </div>
    );
}

function GameInfo({ gameId }) {
    const [gameInfo, setGameInfo] = useState();
    const [gameData, setGameData] = useState();
    const [upload, setUpload] = useState(true);
    const [refresh, setRefresh] = useState(false);
    const [buildUploadProgress, setBuildUploadProgress] = useState(null);
    const keyImage = useRef(null);
    const buildFile = useRef(null);
    const [tags, setTags] = useState([]);
    const [gameTags, setGameTags] = useState([]);
    const [mediaTable, setMediaTable] = useState([]);

    useEffect(() => {
        const req = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: ""
        }

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/GetTagInfo', req)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    data.message.sort((a, b) => {
                        if (a.TagName < b.TagName) {
                            return -1;
                        }
                        if (a.TagName > b.TagName) {
                            return 1;
                        }
                        return 0;
                    });
                    setTags(data.message);
                }
            });
    }, [])

    useEffect(() => {
        GetGameInfo();

        var eventURL = process.env.REACT_APP_NODE_ADDRESS + "/GetGameEvents";

        const eventReqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameId })
        };

        fetch(eventURL, eventReqOptions)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    setGameData(data.message);
                }
            });

    }, [gameId]);

    useEffect(() => {
        if (refresh === true) setRefresh(false);
    }, [refresh])

    useEffect(() => {
        if (IsValid(gameInfo)) {
            var tmpGameInfo = gameInfo;
            tmpGameInfo.TagId = gameTags;
            setGameInfo(tmpGameInfo);
        }
    }, [gameTags]);

    useEffect(() => {
        if (gameInfo === undefined) return;
        setMediaTable(JSON.parse(gameInfo.MediaEntries));
    }, [gameInfo]);

    function GetGameInfo() {
        var URL = process.env.REACT_APP_NODE_ADDRESS + "/GetGameInfo";

        const reqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameId })
        };

        fetch(URL, reqOptions)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    if (IsValid(data.message.PublicBuildLinks) === true) {
                        data.message.PublicBuildLinks = JSON.parse(data.message.PublicBuildLinks);
                    }

                    if (IsValid(data.message.PrivateBuildLinks) === true) {
                        data.message.PrivateBuildLinks = JSON.parse(data.message.PrivateBuildLinks);
                    }
                    setGameInfo(data.message);
                    setGameTags(data.message.TagId);

                    //console.log(data.message);
                }
            });
    }

    function UploadImage(gameId, type, fileContents) {
        setUpload(false);
        const name = `games/${gameId}/${type}.png`

        const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
        const REGION = process.env.REACT_APP_S3_REGION;

        const params = {
            Bucket: S3_BUCKET,
            Key: name,
            Body: fileContents,
        }

        const s3 = new S3Client({
            params: { Bucket: S3_BUCKET },
            region: REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: REGION },
                identityPoolId: "us-east-2:c1eecae6-d846-45d3-a377-6f2377ec8dac",
            }),
            requestHandler: new XhrHttpHandler({}),
            requestChecksumCalculation: 'WHEN_REQUIRED',
        });

        const upload = new Upload({
            client: s3,
            params: params
        });

        upload.on("httpUploadProgress", (progressEvent) => {
            //setBuildUploadProgress({ 'loaded': progressEvent.loaded, 'total': progressEvent.total });
        })

        upload.done().then((err, data) => {
            console.log("File Uploaded");
            setUpload(true);
            var tmpGameInfo = gameInfo;
            tmpGameInfo.BackgroundUrl = gameInfo.BackgroundUrl;
            tmpGameInfo.PhotoUrl = gameInfo.PhotoUrl;
            setGameInfo(tmpGameInfo);
            setRefresh(true);
        });
    }

    async function BuildUpload() {
        setUpload(false);
        var fileName = document.getElementById('uploadBuild').files[0].name;

        const name = `games/${gameInfo.ID}/${fileName}`;

        const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
        const REGION = process.env.REACT_APP_S3_REGION;

        const params = {
            Bucket: S3_BUCKET,
            Key: name,
            Body: document.getElementById('uploadBuild').files[0],
        };

        const s3 = new S3Client({
            params: { Bucket: S3_BUCKET },
            region: REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: {region: REGION },
                identityPoolId: "us-east-2:c1eecae6-d846-45d3-a377-6f2377ec8dac",
            }),
            requestHandler: new XhrHttpHandler({}),
            requestChecksumCalculation: 'WHEN_REQUIRED',
        });

        const upload = new Upload({
            client: s3,
            params: params
        });

        upload.on("httpUploadProgress", (progressEvent) => {
            setBuildUploadProgress({ 'loaded': progressEvent.loaded, 'total': progressEvent.total });
            //console.log("Updating " + parseInt((progressEvent.loaded * 100) / progressEvent.total) + "%");
        })

        upload.done().then((err, data) => {
            console.log("File Uploaded");
            setUpload(true);

            UpdateBuildLinks(name);
        });
    }

    function UpdateBuildLinks(newLink) {
        var eventURL = process.env.REACT_APP_NODE_ADDRESS + "/GameBuildUploaded";

        const eventReqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameId, 'buildLink': newLink })
        };

        fetch(eventURL, eventReqOptions)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    var tempGameInfo = gameInfo;
                    tempGameInfo.PrivateBuildLinks = JSON.parse(data.message);
                    setGameInfo(tempGameInfo);
                    console.log(tempGameInfo);
                    setRefresh(true);
                }
            });
    }

    function CopySecret(event) {
        event.preventDefault();

        navigator.clipboard.writeText(gameInfo.Secret);

        alert("Secret Copied");
    }

    function UploadKeyArtPictureLink(gameId) {
        const keyArt = `games/${gameId}/keyArt.png`
        const background = `games/${gameId}/background.png`
        const req = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                gameId: gameId,
                secretKey: "J*oKUE8TytLJRaE298%-R3VHHnk#ybmtN-x9aA#HBV$hKwC1Q%PzEeHLp%a-(%9EhHJiFfBza*yQ4U-LZLCy8y_prT*YzEIIa12)",
                photoUrl: keyArt
            })
        }

        try {
            fetch(process.env.REACT_APP_NODE_ADDRESS + '/UpdateGame', req)
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        setRefresh(true);
                        //return data;
                    } else {
                        throw new Error(data.message || 'Failed to update game info');
                    }
                });


        } catch (error) {
            console.error('Error updating game info:', error);
            return null;
        }
    }

    function UploadKeyArt() {
        const gameId = gameInfo.ID;
        const keyArt = document.getElementById('uploadKeyArt').files[0];

        UploadImage(gameId, "keyArt", keyArt);
        UploadKeyArtPictureLink(gameId);
    }

    function ToggleVibility() {
        var eventURL = process.env.REACT_APP_NODE_ADDRESS + "/SetGameVisibility";

        const eventReqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameId, 'visibility': !gameInfo.Visibility })
        };

        fetch(eventURL, eventReqOptions)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    var tempGameInfo = gameInfo;
                    tempGameInfo.Visibility = !gameInfo.Visibility;
                    setGameInfo(tempGameInfo);
                    setRefresh(true);
                }
            });
    }

    function UpdateGameInfo() {
        var URL = process.env.REACT_APP_NODE_ADDRESS + "/UpdateGame";

        const reqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameName': gameInfo.Name, 'gameId': gameInfo.ID, 'description': gameInfo.Description, 'tagId': gameTags, 'devNameOverride': gameInfo.DeveloperNameOverride, 'publisherName': gameInfo.PublisherName, 'websiteLink': gameInfo.WebsiteLink, 'steamLink': gameInfo.SteamLink, "freeplay": gameInfo.Freeplay })
        };

        fetch(URL, reqOptions)
            .then((res) => res.json())
            .then((data) => {

            });

        var tmpInfo = {};
        for (var i in gameInfo) {
            tmpInfo[i] = gameInfo[i];
        }
        setGameInfo(tmpInfo);
    }

    function UpdateGameMediaTable(index, type, url) {
        var currTable = mediaTable;

        if (IsValid(currTable) !== true) {
            currTable = [];
        }

        if (index === -1 && type === undefined && url === undefined) {
            currTable.push({ type: "0", URL: "" });
        }
        else {
            currTable[index] = { type: type, URL: url };
            //console.log(currTable);
        }

        //console.log("updating MediaTable");

        setMediaTable([...currTable]);

        const mediaEntriesReqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameInfo.ID, 'mediaEntries': JSON.stringify(currTable) })
        };

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/UpdateMediaEntries', mediaEntriesReqOptions);
    }

    function DeleteGameMediaEntry(index) {
        var currTable = mediaTable;

        currTable.splice(index, 1);

        setMediaTable([...currTable]);

        const mediaEntriesReqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameInfo.ID, 'mediaEntries': JSON.stringify(currTable) })
        };

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/UpdateMediaEntries', mediaEntriesReqOptions);
    }

    function ReorderGameMediaEntry(index, direction) {
        var currTable = mediaTable;

        var oldData = currTable[index]
        currTable[index] = currTable[index + direction];
        currTable[index + direction] = oldData;

        setMediaTable([...currTable]);

        const mediaEntriesReqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameInfo.ID, 'mediaEntries': JSON.stringify(currTable) })
        };

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/UpdateMediaEntries', mediaEntriesReqOptions);
    }

    return (
        <div className="gameInfoPane">
            {IsValid(gameInfo) === true && refresh === false && gameInfo.Status === 4 &&
                <div className="gameInfoForm">
                    <div className="gamePropDiv">
                        <p className="gameVisiblityLabel">Current Visibility:</p><p className="gameVisiblityStatus" style={{ color: gameInfo.Visibility ? "lightgreen" : "red" }}>{gameInfo.Visibility ? "Visible" : "Not Visible"}</p><button className="visiblityToggleButton" onClick={ToggleVibility}>{gameInfo.Visibility ? "Set Not Visible" : "Set Visible"}</button>
                    </div> <br />

                    <div className="gamePropDiv">
                        <label htmlFor="gameId">Game ID:</label> <input className="gameInputField" id="gameId" readOnly value={gameInfo.ID} />
                    </div> <br />
                    <div className="gamePropDiv">
                        <label htmlFor="gameSecret">Game Secret:</label> <input className="gameInputField" type="password" id="gameSecret" readOnly value={gameInfo.Secret} />
                    </div>
                    <button className="copySecretButton accountPageButton" onClick={CopySecret} >Copy Secret</button>
                    <br />
                    <br />

                    <div className="gamePropDiv">
                        <label htmlFor="gameName">Game Name:</label><input className="gameInputField" id="gameName" onChange={(e) => { var tmpInfo = gameInfo; tmpInfo.Name = e.target.value; setGameInfo(tmpInfo); }} defaultValue={gameInfo.Name} />
                    </div> <br />
                    <div className="gamePropDiv">
                        <label htmlFor="gameSecret">Game Description:</label> <textarea className="gameDescField" id="gameSecret" onChange={(e) => { var tmpInfo = gameInfo; tmpInfo.Description = e.target.value; setGameInfo(tmpInfo); }} defaultValue={gameInfo.Description} />
                    </div> <br />
                    <div className="gamePropDiv">
                        <label htmlFor="devOverride">Developer Name Override:</label> <input className="gameInputField" id="devOverride" onChange={(e) => { var tmpInfo = gameInfo; tmpInfo.DeveloperNameOverride = e.target.value; setGameInfo(tmpInfo); }} defaultValue={gameInfo.DeveloperNameOverride} />
                    </div> <br />
                    <div className="gamePropDiv">
                        <label htmlFor="publisher">Publisher Name:</label> <input className="gameInputField" id="publisher" onChange={(e) => { var tmpInfo = gameInfo; tmpInfo.PublisherName = e.target.value; setGameInfo(tmpInfo); }} defaultValue={gameInfo.PublisherName} />
                    </div> <br />
                    <div className="gamePropDiv">
                        <label htmlFor="steamLink">Steam Link:</label> <input className="gameInputField" id="steamLink" onChange={(e) => { var tmpInfo = gameInfo; tmpInfo.SteamLink = e.target.value; setGameInfo(tmpInfo); }} defaultValue={gameInfo.SteamLink} />
                    </div> <br />
                    <div className="gamePropDiv">
                        <label htmlFor="websiteLink">Website Link:</label> <input className="gameInputField" id="websiteLink" onChange={(e) => { var tmpInfo = gameInfo; tmpInfo.WebsiteLink = e.target.value; setGameInfo(tmpInfo); }} defaultValue={gameInfo.WebsiteLink} />
                    </div> <br />
                    <div className="gamePropDiv">
                        <label htmlFor="freeplay">Freeplay Enabled:</label> <input type="checkbox" className="gameInputField" id="freeplay" onChange={(e) => { var tmpInfo = gameInfo; tmpInfo.Freeplay = e.target.checked; setGameInfo(tmpInfo); }} defaultChecked={gameInfo.Freeplay} />
                    </div> <br />
                    <div className="gamePropDiv">
                        <label htmlFor="gameTags">Game Tags:</label>
                        <div className="gameTagsField">
                            {tags.map((tag, index) => {
                                return <GameTagEntry tagName={tag.TagName} tagId={tag.id} currGameTags={gameTags} setCurrGameTags={setGameTags} />
                            })}
                        </div>
                    </div> <br />
                    <button className="gameUpdateButton accountPageButton" onClick={UpdateGameInfo} >Update Game</button>
                    <br />
                    <p className="gameCardPreviewLabel">Library Listing Preview:</p>
                    <div className="gameCardPreview">
                        <GameCard gameId={gameId} gameInfo={gameInfo} />
                    </div>
                    <br />

                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div className="gameUploadFieldDiv">
                            <label htmlFor="uploadKeyArt">Upload Key Art Here:</label>
                            <input type="file" id="uploadKeyArt" ref={keyImage} onChange={UploadKeyArt} style={{ display: 'none' }} />
                            <div className="backgroundUpload" onClick={(e) => { e.preventDefault(); keyImage.current.click(); }} >
                                <img className="uploadImageShow" src={process.env.REACT_APP_S3_BASE_URL + gameInfo.PhotoUrl} alt="Current Key Art" />
                                <p className="uploadText">Click to select file to upload.</p>
                            </div>
                        </div>

                        <div className="gameMediaContainer">
                            <p className="mediaContainerTitle">Media Entries</p>
                            {IsValid(mediaTable) === true && mediaTable.map((tableEntry, index) => {
                                return <GameMediaEntry gameId={gameInfo.ID} mediaInfo={tableEntry} index={index} updateGameMedia={UpdateGameMediaTable} deleteGameMedia={DeleteGameMediaEntry} reorderGameMedia={ReorderGameMediaEntry} isLast={index === mediaTable.length - 1} />
                            })}
                            <NewGameMediaEntry updateGameMedia={UpdateGameMediaTable} />
                        </div>

                        <div className="gameUploadFieldDiv">
                            <label htmlFor="uploadBuild">Upload Game Build Here:</label>
                            <input type="file" id="uploadBuild" ref={buildFile} onChange={BuildUpload} style={{ display: 'none' }} />
                            <div className="backgroundUpload" onClick={(e) => { e.preventDefault(); buildFile.current.click(); }} >
                                <p className="buildFileSelectorName">{IsValid(document.getElementById('uploadBuild')) && IsValid(document.getElementById('uploadBuild').files[0]) ? document.getElementById('uploadBuild').files[0].name : "Upload Build"}</p>
                                <p className="uploadText">Click to select file to upload.</p>
                                {buildUploadProgress !== null &&
                                    <span><br /> <progress id="build" value={(buildUploadProgress.loaded / buildUploadProgress.total) * 100} max="100" /></span>
                                }
                            </div>
                        </div>
                        <div className="buildFieldsDiv">
                            <div className="buildLabelsDiv">
                                <p className="buildNameLabel">File Name:</p>
                                <p className="buildPublicLabel">Is Public:</p>
                                <p className="buildWindowsLabel">Default Windows Build:</p>
                                <p className="buildMacLabel">Default Mac Build:</p>
                                <p className="buildLinuxLabel">Default Linux Build:</p>
                                <p className="buildDeleteLabel">Delete Build:</p>
                                <div className="buildLabelSpacer" />
                            </div>
                            <div className="buildEntriesDiv">
                                {IsValid(gameInfo.PrivateBuildLinks) === true &&
                                    gameInfo.PrivateBuildLinks.map((link, index) => {
                                        return <GameBuildEntry linkInfo={link} gameInfo={gameInfo} setRefresh={setRefresh} updateBuildLinks={GetGameInfo} />
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    {gameData !== undefined && gameData.length > 0 && <div>
                        <h3 className="gameEventHeader">Recent Events</h3>
                        <span className="gameEventEntry"> <p>UserId</p> <p>Timestamp</p> <p>Event</p> </span>
                        {gameData.map((event, index) => {
                            return <span className="gameEventEntry"> <p>{event.UserID}</p> <p>{event.Timestamp.slice(0, 19).replace('T', ' ')}</p> <p>{event.Event}</p> </span>
                        })}
                    </div>}
                </div>
            }
            {gameInfo !== undefined && gameInfo !== null && gameInfo.Status === 1 &&
                <div>
                    <p className="gameUnderReview">Your game is under review.</p>
                </div>
            }
            {gameInfo !== undefined && gameInfo !== null && gameInfo.Status === 2 &&
                <div>
                    <p className="gameChangesNeeded">Please edit your game to be approved.</p>
                </div>
            }
            {gameInfo !== undefined && gameInfo !== null && gameInfo.Status === 3 &&
                <div>
                    <p className="gameDenied">Your game application is deined.</p>
                </div>
            }
        </div>
    );
}


function GameTagEntry({ tagName, tagId, currGameTags, setCurrGameTags }) {
    const [refresh, setRefesh] = useState(false);

    useEffect(() => {
        if (refresh === true) {
            setRefesh(false);
        }
    }, [refresh])

    function AddTag(e) {
        e.preventDefault();

        var tagArray = currGameTags !== null ? currGameTags.split(',') : [];

        if (e.target.checked === false) {
            if (tagArray.length === 1) {
                setCurrGameTags("");
                return;
            }
            tagArray = tagArray.filter((id) => id !== tagId.toString());
        }
        else {
            tagArray.push(tagId);
        }
        setCurrGameTags(tagArray.join(','));
        setRefesh(true);
    }

    function CheckIsEnabled() {
        if (IsValid(currGameTags) !== true) return false;

        var tagArray = currGameTags.split(',');

        for (var i = 0; i < tagArray.length; i++) {
            if (tagArray[i] === tagId.toString()) {
                return true;
            }
        }

        return false;
    }

    return (
        <div className="gameTagEntry">
            {refresh === false && <input className="gameTagCheck" type="checkbox" onChange={AddTag} checked={CheckIsEnabled()} disabled={IsValid(currGameTags) === true && currGameTags.split(',').length >= 4 && currGameTags.split(',').includes(tagId) === false} />}
            <p className="gameTagName">{tagName}</p>
        </div>
    );
}

function GameBuildEntry({ linkInfo, gameInfo, setRefresh, updateBuildLinks }) {
    const [waitForResponse, setWaitForResponse] = useState(false);

    function OnChangePublic(e) {

        setWaitForResponse(true);

        //console.log(e.target.checked);

        if (e.target.checked === true) {
            const signUpReqOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'gameId': gameInfo.ID, 'buildLink': linkInfo })
            };

            fetch(process.env.REACT_APP_NODE_ADDRESS + '/SetBuildPublic', signUpReqOptions)
                .then((res) => res.json())
                .then((data) => {
                    setWaitForResponse(false);
                    //console.log(data);
                    if (data.success === true) {
                        updateBuildLinks();
                        setRefresh(true);
                    }
                });
        }
        else {
            const signUpReqOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'gameId': gameInfo.ID, 'buildLink': linkInfo })
            };

            fetch(process.env.REACT_APP_NODE_ADDRESS + '/RemoveBuildPublic', signUpReqOptions)
                .then((res) => res.json())
                .then((data) => {
                    setWaitForResponse(false);
                    //console.log(data);
                    if (data.success === true) {
                        updateBuildLinks();
                        setRefresh(true);
                    }
                });
        }
    }

    function SetWindowsBuild(e) {
        setWaitForResponse(true);

        var LinkToSend = linkInfo;

        if (e.target.checked === false) {
            LinkToSend = null;
        }

        const signUpReqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameInfo.ID, 'buildLink': LinkToSend })
        };

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/SetWindowsBuild', signUpReqOptions)
            .then((res) => res.json())
            .then((data) => {
                setWaitForResponse(false);
                if (data.success === true) {
                    updateBuildLinks();
                    setRefresh(true);
                }
            });
    }

    function SetMacBuild(e) {
        setWaitForResponse(true);

        var LinkToSend = linkInfo;

        if (e.target.checked === false) {
            LinkToSend = null;
        }

        const signUpReqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameInfo.ID, 'buildLink': LinkToSend })
        };

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/SetMacBuild', signUpReqOptions)
            .then((res) => res.json())
            .then((data) => {
                setWaitForResponse(false);
                if (data.success === true) {
                    updateBuildLinks();
                    setRefresh(true);
                }
            });
    }

    function SetLinuxBuild(e) {
        setWaitForResponse(true);

        var LinkToSend = linkInfo;

        if (e.target.checked === false) {
            LinkToSend = null;
        }

        const signUpReqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameInfo.ID, 'buildLink': LinkToSend })
        };

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/SetLinuxBuild', signUpReqOptions)
            .then((res) => res.json())
            .then((data) => {
                setWaitForResponse(false);
                if (data.success === true) {
                    updateBuildLinks();
                    setRefresh(true);
                }
            });
    }

    function DeleteBuild(e) {
        setWaitForResponse(true);

        const signUpReqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameInfo.ID, 'buildLink': linkInfo })
        };

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/RemoveBuild', signUpReqOptions)
            .then((res) => res.json())
            .then((data) => {
                setWaitForResponse(false);
                if (data.success === true) {
                    updateBuildLinks();
                    setRefresh(true);
                }
            });
    }

    function CheckPublic() {
        return IsValid(gameInfo.PublicBuildLinks) && gameInfo.PublicBuildLinks.includes(linkInfo);
    }

    return (
        <div>
            {IsValid(linkInfo) === true && <div className="buildEntryDiv">
                <p className="buildName">{linkInfo.split('/').pop()}</p>
                <input className="buildPublicCheck" type="checkbox" checked={CheckPublic()} onChange={OnChangePublic} disabled={(waitForResponse !== false)} />
                <input className="buildWindowsCheck" type="checkbox" checked={gameInfo.WindowsBuild === linkInfo} onChange={SetWindowsBuild} disabled={(waitForResponse !== false)} />
                <input className="buildMacCheck" type="checkbox" checked={gameInfo.MacBuild === linkInfo} onChange={SetMacBuild} disabled={(waitForResponse !== false)} />
                <input className="buildLinuxCheck" type="checkbox" checked={gameInfo.LinuxBuild === linkInfo} onChange={SetLinuxBuild} disabled={(waitForResponse !== false)} />
                <button className="deleteBuildButton" onClick={DeleteBuild} disabled={(waitForResponse !== false)}>Delete</button>
            </div>}
        </div>
    );
}

function GameDataPage({ gameId }) {
    const [currPlayers, setCurrPlayers] = useState(0);
    const [sessions, setSessions] = useState(0);
    const [graphData, setGraphData] = useState([["Date", "Sessions"]]);
    const [progData, setProgData] = useState([["Progression Event", "Percentage Players"]])

    const sessionGraphOptions = {
        title: "Game Sessions",
        titleTextStyle: {
            color: "#FFFFFF",
        },
        curveType: "function",
        hAxis: {
            format: "M/d/yy",
            gridlines: {
                count: 5,
            },
            textStyle: {
                color: "#FFFFFF",
            },
        },
        vAxis: {
            title: "Sessions",
            gridlines: { count: 2 },
            textStyle: {
                color: "#FFFFFF",
            },
            format: "#",
            minValue: 0,
        },
        colors: ["#FFCF00"],
        legend: "none",
        height: 300,
        width: '100%',
        backgroundColor: "#000000",
    }

    const levelsGraphOptions = {
        title: "Levels Reached by Players",
        titleTextStyle: {
            color: "#FFFFFF",
        },
        curveType: "function",
        hAxis: {
            format: "M/d/yy",
            gridlines: {
                count: 5,
            },
            textStyle: {
                color: "#FFFFFF",
            },
        },
        vAxis: {
            title: "Sessions",
            gridlines: { count: 2 },
            textStyle: {
                color: "#FFFFFF",
            },
            format: "#",
            minValue: 0,
        },
        colors: ["#FFCF00"],
        legend: "none",
        height: 300,
        width: '100%',
        backgroundColor: "#000000",
    }

    const format = [
        {
            column: 0,
            type: "Date",
            options: {
                timeZone: 0,
                formatType: "short",
            },
        },
    ];

    useEffect(() => {
        const req = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                gameId: gameId,
            })
        }

        console.log("trying to get prog");

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/GetGameDataSummary', req)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    console.log(data);
                    setCurrPlayers(data.message.currentUsers);
                    setSessions(data.message.sessionUsers);

                    var newGraphData = [["Date", "Sessions"]]

                    for (var i = 0; i < data.message.sessionGraphInfo.length; i++) {
                        newGraphData.push([new Date(data.message.sessionGraphInfo[i][0]), data.message.sessionGraphInfo[i][1]]);
                    }
                    console.log(newGraphData);

                    setGraphData(newGraphData);
                }
            });

        const progReq = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                gameId: gameId,
            })
        }

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/GetProgression', progReq)
            .then((res) => res.json())
            .then((data) => {
                console.log(data);
                if (data.success === true) {
                    var progMsg = JSON.parse(data.message);

                    var maxPlayers = 0;
                    var progMap = {};
                    var intData = [];

                    console.log(progMsg);

                    for (const key in progMsg) {
                        for (var i = 0; i < progMsg[key].length; i++) {
                            if (progMap[progMsg[key][i]] === undefined) {
                                progMap[progMsg[key][i]] = 1;
                            }
                            else {
                                progMap[progMsg[key][i]]++;
                            }
                        }
                        maxPlayers++;
                    }

                    console.log(progMap)

                    for (const key in progMap) {
                            intData.push([key, progMap[key] / maxPlayers]);
                    }


                    setProgData([...progData, ...intData]);
                    console.log([...progData, ...intData]);
                }
            });

    }, []);

    return (
        <div>
            <div className="summaryHeader">
                <button className="bigSummaryButton">
                    <div>
                        <p className="dataTitle">Current Players</p>
                        <p className="dataInfo">{currPlayers}</p>
                    </div>
                </button>
                <button className="bigSummaryButton">
                    <div>
                        <p className="dataTitle">Sessions Started</p>
                        <p className="dataInfo">{sessions}</p>
                    </div>
                </button>
            </div>
            <div className="DataDashboard">
                <div className="DashboardHeader">
                    <Chart className="DashboardHeaderChart" chartType="LineChart" data={graphData} options={sessionGraphOptions} formatters={format} />
                </div>
                <div className="DashboardCharts">
                    <Chart className="DashboardDataChart" chartType="LineChart" data={progData} options={levelsGraphOptions} formatters={format} />
                </div>

            </div>
        </div>
    );
}

function GameMediaEntry({ gameId, mediaInfo, index, updateGameMedia, deleteGameMedia, reorderGameMedia, isLast }) {
    const [droppedDown, setDroppedDown] = useState(false);
    const mediaEntry = useRef(null);
    const [currMediaType, setCurrMediaType] = useState(mediaInfo.type);
    const [currMediaURL, setCurrMediaURL] = useState(mediaInfo.URL);

    /*function UploadKeyArt() {
        const gameId = gameInfo.ID;
        const keyArt = document.getElementById('uploadKeyArt').files[0];

        UploadImage(gameId, "keyArt", keyArt);
        UploadKeyArtPictureLink(gameId);
    }*/

    function UploadImage() {
        //setUpload(false);

        const mediaToUpload = document.getElementById("uploadMediaEntry" + index).files[0];
        const name = `games/${gameId}/Media/` + mediaToUpload.name;

        const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
        const REGION = process.env.REACT_APP_S3_REGION;

        const params = {
            Bucket: S3_BUCKET,
            Key: name,
            Body: mediaToUpload,
        }

        const s3 = new S3Client({
            params: { Bucket: S3_BUCKET },
            region: REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: REGION },
                identityPoolId: "us-east-2:c1eecae6-d846-45d3-a377-6f2377ec8dac",
            }),
            requestHandler: new XhrHttpHandler({}),
            requestChecksumCalculation: 'WHEN_REQUIRED',
        });

        const upload = new Upload({
            client: s3,
            params: params
        });

        upload.on("httpUploadProgress", (progressEvent) => {
            //setBuildUploadProgress({ 'loaded': progressEvent.loaded, 'total': progressEvent.total });
        })

        upload.done().then((err, data) => {
            console.log("File Uploaded");
            //setUpload(true);
            //var tmpGameInfo = gameInfo;
            //tmpGameInfo.BackgroundUrl = gameInfo.BackgroundUrl;
            //tmpGameInfo.PhotoUrl = gameInfo.PhotoUrl;
            //setGameInfo(tmpGameInfo);
            //setRefresh(true);
            setCurrMediaURL(process.env.REACT_APP_S3_BASE_URL + name);
        });
    }

    useEffect(() => {
        setCurrMediaType(mediaInfo.type);
        setCurrMediaURL(mediaInfo.URL);
    }, [mediaInfo]);

    useEffect(() => {
        const typeSelect = document.getElementById("mediaType"+index);

        if (typeSelect !== null) {
            typeSelect.value = mediaInfo.type;
        }
    }, [mediaInfo]);

    return (
        <div className="gameMediaEntryContainer">
            <div className="gameMediaEntryTitleLine" onClick={() => { setDroppedDown(!droppedDown); } }>
                <p className="gameMediaEntryTitle">{"Media Entry " + index + ": " + (mediaInfo.type === MediaType.PHOTO ? "Photo" : "") + (mediaInfo.type === MediaType.YOUTUBEVID ? "Video" : "")}</p>
                <p className="gameMediaEntryDroppedIndicator">{droppedDown ? "∨" : "<"}</p>
                <div className="gameMediaReorderContainer">
                    {index !== 0 && <input className="gameMediaReorderButton" type="button" value="⮝" onClick={(e) => { reorderGameMedia(index, -1); e.stopPropagation(); }} />}
                    {isLast === false && <input className="gameMediaReorderButton" type="button" value="⮟" onClick={(e) => { reorderGameMedia(index, 1); e.stopPropagation(); }} />}
                </div>
            </div>
            {droppedDown && <div className="gameMediaDropDown">
                <div className="gameMediaContentEntry">
                    <div className="gameMediaTypeSelector">
                        <p>Media Type:</p>
                        <select id={"mediaType" + index} onChange={(e) => { setCurrMediaType(e.target.value); } } >
                            <option value={MediaType.PHOTO}>Photo</option>
                            <option value={MediaType.YOUTUBEVID}>Video</option>
                        </select>
                    </div>
                    {currMediaType === "0" && <div className="gameMediaPhotoUpload">
                        <input type="file" id={"uploadMediaEntry" + index} ref={mediaEntry} onChange={UploadImage} style={{ display: 'none' }} />
                        <div className="gameMediaEntryPhotoUpload" onClick={(e) => { e.preventDefault(); mediaEntry.current.click(); }} >
                            <img className="gameMediaImagePreview" src={currMediaURL} alt="Current Key Art" />
                            <p className="uploadText">Click to select file to upload.</p>
                        </div>
                    </div>}
                    {currMediaType === "1" && <div className="gameMediaVideoLinkentry">
                        <p>Video Link (only YouTube links):</p>
                        <input className="gameMediaVideoUrlInput" type="text" defaultValue={currMediaURL} onChange={(e) => { setCurrMediaURL(e.target.value); }} />
                        {(currMediaURL !== undefined && currMediaURL !== null && currMediaURL !== "") && <iframe className="gameMediaVideoUrlPreview" src={currMediaURL} />}
                    </div>}
                </div>
                <div className="gameMediaEntryButtons">
                    <input className="gameMediaEntryUpdateButton" type="button" value="Update" onClick={() => { updateGameMedia(index, currMediaType, currMediaURL) }} />
                    <input className="gameMediaEntryDeleteButton" type="button" value="Delete" onClick={() => { deleteGameMedia(index) }} />
                </div>
            </div>}
            
        </div>
    );
}

//<Dropdown data={MediaDropdownTypes} maxHeight={200} />

function NewGameMediaEntry({ updateGameMedia }) {

    return (
        <div className="newMediaEntryContainer" onClick={() => { console.log("Try add new media"); updateGameMedia(-1); } }>
            <p className="addMediaEntrySign">+</p>
            <p className="addMediaEntryText">Add Media</p>
        </div>
    );
}

export default GamePage;